import { Box, Typography } from '@mui/material';
import { CuriosityTranslation } from '@procureai/curiosity-ui-mui';

import { UserEntity, UserHitId } from '../UserAutocomplete.types';
import { UserAvatar } from '~/components/UserAvatar/UserAvatar';

import { Root } from './UserOption.styled';

export interface UserOptionProps {
  data: CuriosityTranslation<UserEntity>;
}

export const UserOption = ({ data, ...props }: UserOptionProps) => {
  let avatar;

  if (data.id === UserHitId.UNASSIGNED || data.id === UserHitId.ME) {
    avatar = <UserAvatar alt={data.value} />;
  } else {
    avatar = <UserAvatar alt={data.value} user={data.entity} />;
  }

  return (
    <Root {...props}>
      {avatar}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          ml: 3,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: 'text.primary',
          }}
        >
          {data.value}
        </Typography>
        {data.entity.email ? (
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              display: 'block',
            }}
          >
            {data.entity.email}
          </Typography>
        ) : null}
      </Box>
    </Root>
  );
};
